<template>
  <div>
    <div class="reply-container">
      <p class="notification-subtitle paddingBottom no-margin">Location name (optional) (Max 25 characters)</p>
      <div class="counter-wrapper">
        <VTextField
          v-model="localName"
          placeholder="Enter Location name"
          :maxlength="25"
          aria-label="Enter Location name"
          appearance="ghost"
          class="vivid-input"
          @blur="emitChange"
        ></VTextField>
        <div class="custom-counter">{{ (localName || '').length }}/25</div>
      </div>
    </div>

    <div class="reply-container">
      <p class="notification-subtitle paddingBottom no-margin">Address</p>
      <autofill-address v-model="localAddress" class="vivid-input width100P" @onSearch="onSearch"></autofill-address>
    </div>

    <div class="row-divider">
      <div class="group-divider">
        <span>OR</span>
      </div>
    </div>

    <div class="flex-between">
      <div class="flex100P">
        <p class="notification-subtitle paddingBottom no-margin">Latitude</p>
        <VTextField
          v-model="localLat"
          placeholder="Enter latitude"
          :maxlength="25"
          aria-label="Enter latitude"
          appearance="ghost"
          class="vivid-input"
          @blur="emitChange"
        ></VTextField>
      </div>
      <div class="flex100P">
        <p class="notification-subtitle paddingBottom no-margin">Longitude</p>
        <VTextField
          v-model="localLng"
          placeholder="Enter longitude"
          :maxlength="25"
          aria-label="Enter longitude"
          appearance="ghost"
          class="vivid-input"
          @blur="emitChange"
        ></VTextField>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import autofillAddress from '@/components/autofill-address.vue';

export interface LocationPayload {
  name: string | undefined
  address: string | undefined
  lat: string | undefined
  lng: string | undefined
}

const props = defineProps<{
  modelValue: LocationPayload
}>();

const emit = defineEmits<{
  'update:modelValue': [value: LocationPayload]
}>();

const localName = ref<string | undefined>(props.modelValue.name);
const localAddress = ref<string | undefined>(props.modelValue.address);
const localLat = ref<string | undefined>(props.modelValue.lat);
const localLng = ref<string | undefined>(props.modelValue.lng);

watch(() => props.modelValue, (val) => {
  localName.value = val.name;
  localAddress.value = val.address;
  localLat.value = val.lat;
  localLng.value = val.lng;
}, { deep: true });

interface LocationSearchResult {
  autoFillAddress?: string
  sendLocationLatitudeText?: string
  sendLocationLongitudeText?: string
}

function onSearch(locationForm: LocationSearchResult) {
  localAddress.value = locationForm.autoFillAddress;
  localLat.value = locationForm.sendLocationLatitudeText;
  localLng.value = locationForm.sendLocationLongitudeText;
  emitChange();
}

function emitChange() {
  emit('update:modelValue', {
    name: localName.value,
    address: localAddress.value,
    lat: localLat.value,
    lng: localLng.value,
  });
}
</script>

<style scoped>
.reply-container {
  margin-bottom: 15px;
  margin-top: 15px;
}
.paddingBottom {
  padding-bottom: 10px;
}
.no-margin {
  margin: 0;
}
.group-divider {
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid var(--background-primary);
  width: 100%;
  margin: 0px 0px 20px 0px;
}
.group-divider span {
  background: var(--white);
  padding: 0 10px;
  position: relative;
  top: 10px;
  font-size: 12px;
  color: var(--gray-04);
}
.row-divider {
  display: flex;
  align-items: center;
}
.flex-between {
  display: flex;
  gap: 10px;
}
.flex100P {
  flex: 1;
}
</style>
